<template>
    <div class="landing-page settings">
        <template v-if="isLoading">
            <div class="loader">
                <svg class="circular" viewBox="25 25 50 50">
                    <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"/>
                </svg>
            </div>
        </template>
        <template v-else>
            <div class="settings-row fixed-width title">
                Settings
            </div>
            <div class="settings-row fixed-width">
                <div class="settings-col">
                    <div class="title">Monitored domains</div>
                    <div class="description">You can add as many domains as you want, as long as you stay within your page limit.</div>
                </div>
                <div class="settings-row domain-block">
                <span v-for="(item, index) in settings.domains" :key="item" class="domain-label">
                    <span>{{item}}</span>
                    <span @click="() => {clearDomain(index)}" class="clear-btn"><svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23196 0.592675L3.49996 2.86067L5.75863 0.602008C5.83862 0.516888 5.94982 0.468028 6.06663 0.466675C6.32437 0.466675 6.5333 0.675601 6.5333 0.933341C6.53549 1.04898 6.4899 1.16042 6.4073 1.24134L4.1253 3.50001L6.4073 5.78201C6.4842 5.85723 6.52933 5.95915 6.5333 6.06667C6.5333 6.32441 6.32437 6.53334 6.06663 6.53334C5.94637 6.53833 5.82956 6.4926 5.74463 6.40734L3.49996 4.13934L1.23663 6.40267C1.15697 6.48495 1.04777 6.53199 0.933295 6.53334C0.675555 6.53334 0.466628 6.32441 0.466628 6.06667C0.464435 5.95103 0.510028 5.83959 0.592628 5.75867L2.87463 3.50001L0.592628 1.21801C0.515722 1.14278 0.470595 1.04086 0.466628 0.933341C0.466628 0.675601 0.675555 0.466675 0.933295 0.466675C1.04548 0.468028 1.15268 0.513248 1.23196 0.592675Z" fill="#495057"/></svg></span>
                </span>
                    <div :class="{'multiselect-domains': true, 'disabled': currentPageCount >= settings.pagesCount}">
                        <div :class="{'add-new': true, 'disabled': currentPageCount >= settings.pagesCount}">+ Add a domain</div>
                        <multiselect
                            @input="addDomain"
                            :value="domainValues"
                            :options="availableDomains"
                            :multiple="true"

                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="true"
                            track-by="id"
                            label="name"
                        />
                    </div>
                </div>
            </div>
            <div class="settings-row fixed-width">
                <div class="settings-col">
                    <div class="title">Monitored landing pages</div>
                    <div class="description">We automatically import final URLs from your Google Ads campaigns.</div>
                </div>
                <div class="settings-col">
                    <div class="progress">
                        <div :style="`width: ${currentPageProgress}%; ${currentPageCount > settings.pagesCount ? 'background-color: red' : ''}`" />
                    </div>
                    <div class="pages-upgrade">
                        <div>
                            <span class="current-pages">{{currentPageCount}}</span>
                            <span>/{{ settings.pagesCount }} pages</span>
                        </div>
                        <div class="upgrade">Upgrade</div>
                    </div>
                    <div class="settings-col">
                        <div class="additional-pages">
                            <div v-for="(item, index) in settings.additionalPages" :key="index" class="settings-row receiver">
                                <div :class="{'receiver-input': true}">
                                    <input :name="'additionalPages.'+index" v-model="settings.additionalPages[index]" @blur="save" placeholder="Site url">
                                    <span @click="() => {clearCustomPage(index)}" class="clear-btn"><svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23196 0.592675L3.49996 2.86067L5.75863 0.602008C5.83862 0.516888 5.94982 0.468028 6.06663 0.466675C6.32437 0.466675 6.5333 0.675601 6.5333 0.933341C6.53549 1.04898 6.4899 1.16042 6.4073 1.24134L4.1253 3.50001L6.4073 5.78201C6.4842 5.85723 6.52933 5.95915 6.5333 6.06667C6.5333 6.32441 6.32437 6.53334 6.06663 6.53334C5.94637 6.53833 5.82956 6.4926 5.74463 6.40734L3.49996 4.13934L1.23663 6.40267C1.15697 6.48495 1.04777 6.53199 0.933295 6.53334C0.675555 6.53334 0.466628 6.32441 0.466628 6.06667C0.464435 5.95103 0.510028 5.83959 0.592628 5.75867L2.87463 3.50001L0.592628 1.21801C0.515722 1.14278 0.470595 1.04086 0.466628 0.933341C0.466628 0.675601 0.675555 0.466675 0.933295 0.466675C1.04548 0.468028 1.15268 0.513248 1.23196 0.592675Z" fill="#495057"/></svg></span>
                                </div>
                            </div>
                        </div>
                        <div class="settings-row">
                            <div
                                @click="() => {settings.additionalPages.push('')}"
                                :class="{'add-new': true, 'disabled': !isProPlan || (currentPageCount >= settings.pagesCount)}"
                            >+ Add pages</div>
                            <span class="for-pro-plan">
                                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_160_32)"><path d="M7.98217 3.07121C7.93937 2.93953 7.82556 2.84356 7.68856 2.82368L5.3652 2.48612L4.32613 0.380607C4.26486 0.256464 4.13841 0.177856 3.99999 0.177856C3.86154 0.177856 3.73509 0.256464 3.67385 0.380607L2.63485 2.48609L0.311411 2.82365C0.174417 2.84356 0.0605787 2.93953 0.0178076 3.07119C-0.0249636 3.20287 0.0107033 3.34741 0.109848 3.44403L1.79109 5.08267L1.39405 7.39692C1.37065 7.53338 1.42673 7.67127 1.53873 7.75264C1.60209 7.79869 1.67713 7.82211 1.75254 7.82211C1.81041 7.82211 1.86853 7.80831 1.92176 7.78033L3.99996 6.6878L6.07815 7.78033C6.13168 7.80848 6.19031 7.82189 6.24838 7.82211C6.44903 7.82182 6.61158 7.6591 6.61158 7.45841C6.61158 7.43048 6.60842 7.40325 6.60246 7.37713L6.20886 5.08269L7.8901 3.44403C7.98927 3.34741 8.02494 3.20287 7.98217 3.07121Z" fill="#6F747D"/></g><defs><clipPath id="clip0_160_32"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
                                PRO
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="settings-row fixed-width">
                <div class="settings-col">
                    <div class="title">
                        Email alerts
                        <svg
                            v-if="!settings.sendEmailNotification"
                            @click="pressEmailAlertsBtn"
                            viewBox="0 0 24 24"><path d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4 9.91 6.09 12 8.18V4z"></path></svg>
                        <svg
                            v-else
                            class="enabled"
                            @click="pressEmailAlertsBtn"
                            width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.9233 0.0886414L7.06262 3.45864V12.542L12.9233 15.912C13.4073 16.1893 13.9713 15.7773 13.9713 15.1486V0.852642C13.9713 0.222641 13.4066 -0.190025 12.9233 0.0893081V0.0886414Z" fill="#495057"/><path d="M6.33532 3.81805L3.05132 3.82472C2.64732 3.86272 2.33398 4.19938 2.33398 4.61005C2.33398 4.62872 2.33465 4.64805 2.33598 4.66672V4.66405V11.5014C2.33465 11.518 2.33398 11.538 2.33398 11.5574C2.33398 11.9634 2.64532 12.2967 3.04198 12.332H3.04465H6.33465V3.81738L6.33532 3.81805Z" fill="#495057"/></svg>
                    </div>
                    <div class="description">You can add as many domains as you want, as long as you stay within your page limit.</div>
                </div>
                <div class="settings-col">
                    <div class="mb-4">Alert after the page is down for <span class="like-link pointer" @click="() => {$modal.show('timeout-modal')}">{{settings.responseTimeout}} sec</span></div>
                    <div>Send alerts to</div>
                    <div v-for="(receiver, index) in settings.receivers" :key="index" class="settings-row receiver">
                        <div :class="{'receiver-input': true, 'disabled': index === 0}">
                            <input :name="'receivers.'+index+'.email'" v-model="settings.receivers[index]['email']" @blur="save" placeholder="Email">
                            <span v-if="index !== 0" @click="() => {clearReceiver(index)}" class="clear-btn"><svg width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.23196 0.592675L3.49996 2.86067L5.75863 0.602008C5.83862 0.516888 5.94982 0.468028 6.06663 0.466675C6.32437 0.466675 6.5333 0.675601 6.5333 0.933341C6.53549 1.04898 6.4899 1.16042 6.4073 1.24134L4.1253 3.50001L6.4073 5.78201C6.4842 5.85723 6.52933 5.95915 6.5333 6.06667C6.5333 6.32441 6.32437 6.53334 6.06663 6.53334C5.94637 6.53833 5.82956 6.4926 5.74463 6.40734L3.49996 4.13934L1.23663 6.40267C1.15697 6.48495 1.04777 6.53199 0.933295 6.53334C0.675555 6.53334 0.466628 6.32441 0.466628 6.06667C0.464435 5.95103 0.510028 5.83959 0.592628 5.75867L2.87463 3.50001L0.592628 1.21801C0.515722 1.14278 0.470595 1.04086 0.466628 0.933341C0.466628 0.675601 0.675555 0.466675 0.933295 0.466675C1.04548 0.468028 1.15268 0.513248 1.23196 0.592675Z" fill="#495057"/></svg></span>
                        </div>
                        <template v-if="index !== 0">
                            <span @click="() => {editReminderFor(index)}" :class="{'frequency':true, 'disabled': !isProPlan}">{{getEditFrequencyBtnName(receiver)}}</span>
                            <span class="for-pro-plan">
                            <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_160_32)"><path d="M7.98217 3.07121C7.93937 2.93953 7.82556 2.84356 7.68856 2.82368L5.3652 2.48612L4.32613 0.380607C4.26486 0.256464 4.13841 0.177856 3.99999 0.177856C3.86154 0.177856 3.73509 0.256464 3.67385 0.380607L2.63485 2.48609L0.311411 2.82365C0.174417 2.84356 0.0605787 2.93953 0.0178076 3.07119C-0.0249636 3.20287 0.0107033 3.34741 0.109848 3.44403L1.79109 5.08267L1.39405 7.39692C1.37065 7.53338 1.42673 7.67127 1.53873 7.75264C1.60209 7.79869 1.67713 7.82211 1.75254 7.82211C1.81041 7.82211 1.86853 7.80831 1.92176 7.78033L3.99996 6.6878L6.07815 7.78033C6.13168 7.80848 6.19031 7.82189 6.24838 7.82211C6.44903 7.82182 6.61158 7.6591 6.61158 7.45841C6.61158 7.43048 6.60842 7.40325 6.60246 7.37713L6.20886 5.08269L7.8901 3.44403C7.98927 3.34741 8.02494 3.20287 7.98217 3.07121Z" fill="#6F747D"/></g><defs><clipPath id="clip0_160_32"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
                            PRO
                        </span>
                        </template>
                    </div>
                    <div
                        @click="() => {settings.receivers.push({
                            reminderAlertAfterHours: this.settings.reminderAlertAfterHours,
                            repeatAlertWeekly: this.settings.repeatAlertWeekly,
                            useMainSettings: true,
                        })}"
                        :class="{'mb-4 add-new': true, 'disabled': settings.receivers.length >= maxEmailSendTo}"
                    >+ Add a recipient</div>
                    <div>Send a reminder about unresolved issues after <span @click="() => {editReminderFor()}" class="like-link pointer">24 hours, repeat weekly.</span></div>
                </div>
            </div>
            <div class="settings-row fixed-width">
                <div class="settings-col">
                    <div class="title">SSL/TLS certificates</div>
                </div>
                <div class="settings-col">
                    <div :class="{'toggle-block': true, 'disabled': !isProPlan}">
                        <toggle-button v-model="settings.certificateCheck" @change="save" color="#3CBA54"/>
                        Monitor SSL/TLS certificate
                        <span class="for-pro-plan">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_160_32)"><path d="M7.98217 3.07121C7.93937 2.93953 7.82556 2.84356 7.68856 2.82368L5.3652 2.48612L4.32613 0.380607C4.26486 0.256464 4.13841 0.177856 3.99999 0.177856C3.86154 0.177856 3.73509 0.256464 3.67385 0.380607L2.63485 2.48609L0.311411 2.82365C0.174417 2.84356 0.0605787 2.93953 0.0178076 3.07119C-0.0249636 3.20287 0.0107033 3.34741 0.109848 3.44403L1.79109 5.08267L1.39405 7.39692C1.37065 7.53338 1.42673 7.67127 1.53873 7.75264C1.60209 7.79869 1.67713 7.82211 1.75254 7.82211C1.81041 7.82211 1.86853 7.80831 1.92176 7.78033L3.99996 6.6878L6.07815 7.78033C6.13168 7.80848 6.19031 7.82189 6.24838 7.82211C6.44903 7.82182 6.61158 7.6591 6.61158 7.45841C6.61158 7.43048 6.60842 7.40325 6.60246 7.37713L6.20886 5.08269L7.8901 3.44403C7.98927 3.34741 8.02494 3.20287 7.98217 3.07121Z" fill="#6F747D"/></g><defs><clipPath id="clip0_160_32"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
                        PRO
                    </span>
                    </div>
                </div>
            </div>
            <div class="settings-row fixed-width">
                <div class="settings-col">
                    <div class="title">Monitored ads</div>
                    <div class="description">By default, we monitor landing page in all active ads.</div>
                </div>
                <div class="settings-col">
                    <div class="toggle-block">
                        <toggle-button v-model="settings.monitorActiveAds" @change="save" color="#3CBA54"/>
                        Monitor all active ads (default)
                    </div>
                    <div :class="{'toggle-block': true, 'disabled': !isProPlan}">
                        <toggle-button v-model="settings.monitorPausedAds" @change="save" color="#3CBA54"/>
                        Monitor all paused ads
                        <span class="for-pro-plan">
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_160_32)"><path d="M7.98217 3.07121C7.93937 2.93953 7.82556 2.84356 7.68856 2.82368L5.3652 2.48612L4.32613 0.380607C4.26486 0.256464 4.13841 0.177856 3.99999 0.177856C3.86154 0.177856 3.73509 0.256464 3.67385 0.380607L2.63485 2.48609L0.311411 2.82365C0.174417 2.84356 0.0605787 2.93953 0.0178076 3.07119C-0.0249636 3.20287 0.0107033 3.34741 0.109848 3.44403L1.79109 5.08267L1.39405 7.39692C1.37065 7.53338 1.42673 7.67127 1.53873 7.75264C1.60209 7.79869 1.67713 7.82211 1.75254 7.82211C1.81041 7.82211 1.86853 7.80831 1.92176 7.78033L3.99996 6.6878L6.07815 7.78033C6.13168 7.80848 6.19031 7.82189 6.24838 7.82211C6.44903 7.82182 6.61158 7.6591 6.61158 7.45841C6.61158 7.43048 6.60842 7.40325 6.60246 7.37713L6.20886 5.08269L7.8901 3.44403C7.98927 3.34741 8.02494 3.20287 7.98217 3.07121Z" fill="#6F747D"/></g><defs><clipPath id="clip0_160_32"><rect width="8" height="8" fill="white"/></clipPath></defs></svg>
                        PRO
                    </span>
                    </div>
                </div>
            </div>
            <modal :height="'auto'" :width="'400px'" name="timeout-modal">
                <div class="informative-modal flex flex-col">
                    <div class="header">
                        Alert after the page is down
                    </div>
                    <div class="body">
                        <div class="label">Select a response time for your pages</div>
                        <vue-slider
                            v-model="settings.responseTimeout"
                            :max="30"
                            :min="1"
                        />
                    </div>
                    <div class="footer flex justify-end space-x-2">
                        <button class="btn" @click="() => {$modal.hide('timeout-modal')}">Close</button>
                        <button class="btn btn-primary ml-2" @click="saveTimeout">Save</button>
                    </div>
                </div>
            </modal>
            <modal :height="'auto'" :width="'400px'" name="email-mute-modal">
                <div class="informative-modal flex flex-col">
                    <div class="header">
                        Mute email alerts
                    </div>
                    <div class="body">
                        Please use this with caution. If you disable alerts, issues with your landing pages might remain unnoticed and result in money losses. If you’re 100% sure, mute alerts for
                        <custom-input
                            name="your_industry"
                            type="select"
                            v-model="settings.muteAlertsFor"
                            value_name="name"
                            :select_options="muteAlertsOptions"
                        ></custom-input>
                    </div>
                    <div class="footer flex justify-end space-x-2">
                        <button class="btn" @click="() => {$modal.hide('email-mute-modal')}">Close</button>
                        <button class="btn btn-primary ml-2" @click="saveMuteAlerts">Save</button>
                    </div>
                </div>
            </modal>
            <modal :height="'auto'" :width="'400px'" name="reminders-modal">
                <div class="informative-modal flex flex-col">
                    <div class="header">
                        Reminders
                    </div>
                    <div class="body">
                        <div v-if="currentEmailSettings !== settings">
                            <div class="toggle-block">
                                <toggle-button v-model="currentEmailSettings.useMainSettings" color="#3CBA54"/>
                                Use default settings
                            </div>
                        </div>
                        <div :class="{'disabled': currentEmailSettings.useMainSettings}">
                            <div class="label">Send reminders about unresolved issues every</div>
                            <vue-slider
                                v-model="currentEmailSettings.reminderAlertAfterHours"
                                :max="24"
                                :min="1"
                            />
                        </div>
                        <div :class="{'disabled': currentEmailSettings.useMainSettings}">
                            <div class="label">How often?</div>
                            <toggle-button
                                v-model="currentEmailSettings.repeatAlertWeekly"
                                :color="currentEmailSettings.useMainSettings ? {checked: '#989292', unchecked: '#989292'} : {checked: '#3CBA54', unchecked: '#4285F4'}"
                                :labels="{checked: 'Weekly', unchecked: 'Just once'}"
                                :switch-color="{checked: 'white', unchecked: 'white'}"
                                :width="90"
                                :font-size="12"
                            />
                        </div>

                    </div>
                    <div class="footer flex justify-end space-x-2">
                        <button class="btn" @click="() => {$modal.hide('reminders-modal')}">Close</button>
                        <button class="btn btn-primary ml-2" @click="() => {save(); $modal.hide('reminders-modal');}">Save</button>
                    </div>
                </div>
            </modal>
        </template>
    </div>
</template>

<script>


import Multiselect from "vue-multiselect";

export default {
    name: 'landing-settings',
    props: [],
    components: {
        Multiselect
    },
    data: function () {
        return {
            isLoading: false,
            maxEmailSendTo: 10,
            isProPlan: true, //todo move to props?
            availableDomains: [],
            muteAlertsOptions: [{name: '24h', value: 24}, {name: '7 days', value: 24*7}, {name: '14 days', value: 24*14}],
            currentEmailSettings: {
                reminderAlertAfterHours: 24,
                repeatAlertWeekly: true,
                useMainSettings: true,
            },
            settings:{
                additionalPages: [],
                domains: [],
                pagesCount: 10,
                responseTimeout: 30,
                sendEmailNotification: true,
                muteAlertsFor: {},
                monitorActiveAds: true,
                monitorPausedAds: false,
                certificateCheck: false,
                receivers: [],

                reminderAlertAfterHours: '',
                repeatAlertWeekly: true,
            }
        }
    },
    computed: {
        currentPageCount: function (){
            let count = 0;
            this.domainValues.forEach(e => {
                if(this.settings.monitorActiveAds) count += e.active_pages;
                if(this.settings.monitorPausedAds) count += e.paused_pages;
            });
            count += this.settings.additionalPages.length;
            return count;
        },
        currentPageProgress: function (){
            let percent = this.currentPageCount/this.settings.pagesCount*100;
            if(percent > 100) percent = 100;
            return percent;
        },
        domainValues: function(){
            return this.settings.domains.map(
                name => {
                    return this.availableDomains.find(o => o.name === name);
                }
            );
        },
    },
    methods: {
        getEditFrequencyBtnName(emailSettings){
            if(emailSettings.useMainSettings) return 'Edit frequency';
            if('reminderAlertAfterHours' in emailSettings) {
                let str = '' + emailSettings.reminderAlertAfterHours;

                if(emailSettings.reminderAlertAfterHours === 1) str += ' hour';
                else str += ' hours';

                if(emailSettings.repeatAlertWeekly) str += ', repeat weekly';
                else str += ', just once';

                return str;
            }
            return 'Edit frequency';
        },
        saveReminder(){
            this.currentEmailSettings = null;
            this.save();
            this.$modal.hide('reminders-modal');
        },
        editReminderFor(index){
            if(!index) this.currentEmailSettings = this.settings;
            else {
                this.currentEmailSettings = this.settings.receivers[index];
            }

            this.$modal.show('reminders-modal');
        },
        save(){
            let page = $('.landing-page.settings');
            axios.post('/landing-pages/settings/save', {
                ...this.settings,
                muteAlertsFor: this.settings.muteAlertsFor.value,
            })
                .then(() => {
                    $.each(this.settings, function (i, element) {
                        if(Array.isArray(element)){
                            $.each(element, function (index, element) {
                                let name = i+'.'+index;
                                if(i === 'receivers') name +=  '.email';
                                let el = page.find('[name="'+name+'"]');
                                el.parent().removeClass('error');
                            });
                        }
                        let el = page.find('[name="' + i + '"]');
                        el.parent().removeClass('error');
                        /*let label = page.find('.input-group__labels [for="' + i + '"]');
                        label.addClass('error');
                        label.text(error);*/
                    });
                })
                .catch(err => {
                    if (err.response && err.response.status === 422) {
                        $.each(err.response.data.errors, function (i, error) {
                            let el = page.find('[name="' + i + '"]');
                            el.parent().addClass('error');
                            /*let label = page.find('.input-group__labels [for="' + i + '"]');
                            label.addClass('error');
                            label.text(error);*/
                        });
                    } else {
                        console.log('err', err);
                    }
                });
        },
        saveMuteAlerts(){
            this.$modal.hide('email-mute-modal');
            this.settings.sendEmailNotification = false;
            this.save();
        },
        saveTimeout(){
            this.$modal.hide('timeout-modal');
            this.save();
        },
        pressEmailAlertsBtn(){
           if(this.settings.sendEmailNotification){
               this.settings.muteAlertsFor = this.muteAlertsOptions[0];
               this.$modal.show('email-mute-modal');
           }
           else{
               this.settings.sendEmailNotification = true;
               this.save();
           }
        },
        clearCustomPage(index){
            this.settings.additionalPages.splice(index, 1);
            this.save();
        },
        clearDomain(index) {
            this.settings.domains.splice(index, 1);
            this.save();
        },
        addDomain(value){
            this.settings.domains = value.map((item) => item.name);
            this.save();
        },
        clearReceiver(index) {
            //this.$set(this.settings.receivers, index, '');
            this.settings.receivers.splice(index, 1);
            this.save();
        },
        loadSettings(){
            this.isLoading = true;
            axios.post('/landing-pages/settings/load')
                .then((res) => {
                    let data = res.data.settings;
                    data.muteAlertsFor = {};

                    this.settings = data;
                    this.availableDomains = res.data.availableDomains;
                }).finally(() => {
                    this.isLoading = false;
                });
        },
    },
    mounted() {
        this.loadSettings();
    },
}
</script>
